export function environmentPath(workspaceId: number): { environment_id: string } {
  return { environment_id: String(workspaceId) };
}

export function snippetPath(workspaceId: number, snippetId: string): { environment_id: string; id: string } {
  return { ...environmentPath(workspaceId), id: snippetId };
}
